function Skeleton() {
  return (
    <div className="mx-auto flex w-72 animate-pulse flex-col items-center gap-3">
      {Array(5)
        .fill(0)
        .map((_, index) => (
          <div
            key={index}
            className="h-16 w-full rounded-2xl bg-gray-200 dark:bg-gray-700"
          ></div>
        ))}
    </div>
  );
}

export default Skeleton;
